import styled from 'styled-components'
import { grid } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Button as BaseButton, Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    width: 1,
    justifyContent: 'center',
    pb: [16, 32],
    px: LANDING_INLINE_PADDINGS,
  })
  .withConfig({
    shouldForwardProp,
  })`
  position: relative;
  background-color: ${themeGet('colors.bg.secondary')};
`

export const Content = styled.div
  .attrs({
    gridGap: [16, 32],
    gridTemplateColumns: [
      `repeat(1, minmax(150px, 1fr))`,
      `repeat(1, minmax(150px, 1fr))`,
      `repeat(1, minmax(150px, 1fr))`,
      `repeat(2, minmax(150px, 1fr))`,
    ],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: grid;
  width: 100%;

  ${grid}
`

export const Pagination = styled.nav`
  position: absolute;
  bottom: -84px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 16px;
`

export const PageButton = styled(BaseButton).attrs({
  as: 'a',
})`
  background-color: ${themeGet('colors.surface.block')};
  text-decoration: none;

  &:hover {
    background-color: ${themeGet('colors.surface.screen')};
  }
`

export const PageInfo = styled.span`
  color: ${themeGet('colors.text.muted')};
  white-space: nowrap;
`
